import { render, staticRenderFns } from "./ReferralsStatus.vue?vue&type=template&id=0194ac5b&scoped=true"
import script from "./ReferralsStatus.vue?vue&type=script&lang=js"
export * from "./ReferralsStatus.vue?vue&type=script&lang=js"
import style0 from "./ReferralsStatus.vue?vue&type=style&index=0&id=0194ac5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194ac5b",
  null
  
)

export default component.exports